/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_DescriptionInputs */

const en_pronunciation_report_description = /** @type {(inputs: Pronunciation_Report_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the passage in view while you write your correction.`)
};

const es_pronunciation_report_description = /** @type {(inputs: Pronunciation_Report_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén el pasaje a la vista mientras escribes tu corrección.`)
};

/**
* | output |
* | --- |
* | "Keep the passage in view while you write your correction." |
*
* @param {Pronunciation_Report_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_description = /** @type {((inputs?: Pronunciation_Report_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_description(inputs)
	return en_pronunciation_report_description(inputs)
});